import React, { Component } from 'react';
import UserProvider from '../js/userProvider';
import AuthService from './AuthService';

export default function WithAuth(AuthComponent) {

    const Auth = new AuthService('http://localhost:8080');

    return class AuthWrapped extends Component {

        constructor(props) {
            super(props);

            this.state = {
                user: null,
                ui: null
            }

            this.redirect = "";
            this.uiFilial = "";
            this.uiPessoa = "";
            this.doRedirect = true;

            let userData = UserProvider.getInstance();

            //https://portal.taxidigital.net/MotoPWA/#/perfil-simples?cdFilial=1232&cdPessoa=123
            //http://localhost:3000/MotoPWA/#/perfil-simples?cdFilial=1232&cdPessoa=123
            console.log(this.props);

            if (this.props.pageLocation && this.props.pageLocation.hash && this.props.pageLocation.hash !== "") {

                this.hash = this.props.pageLocation.hash;

                console.log(this.props, this.hash.indexOf("&cdPessoa="), this.hash.indexOf("?cdFilial="));

                if (this.hash.indexOf("&cdPessoa=") > -1 && this.hash.indexOf("?cdFilial=") > -1) {

                    var hash = this.hash.split("?");
                    this.redirect = this.hash.replace("#/", "");
                    //var pieces = hash[1].split("&");
                    //this.dadosProvider.setCdFilial(pieces[0].replace("cdFilial=", ""));
                    //this.dadosProvider.setCdPessoa(pieces[1].replace("cdPessoa=", ""));

                    this.doRedirect = false;
                }
            } else if (this.props.pageLocation && this.props.pageLocation.search && this.props.pageLocation.search !== "") {
                this.redirect = this.props.pageLocation.search;


                if (this.redirect.indexOf("&uiPessoa=") > -1) {

                    var pieces = this.redirect.split("&uiPessoa=");
                    this.uiFilial = pieces[0].replace("?uiFilial=", "");
                    this.uiPessoa = pieces[1].replace("&uiPessoa=", "");

                    if (this.uiPessoa.indexOf("&etc=") > -1) {
                        var pieces2 = this.uiPessoa.split("&etc=");
                        this.uiPessoa = pieces2[0];
                    }

                    userData.setUiFilial(this.uiFilial);

                } else if (this.hash.indexOf("&cdPessoa=") > -1 && this.hash.indexOf("?cdFilial=") > -1) {
                    this.doRedirect = false;
                } else {
                    userData.setUiFilial(this.redirect.replace("?uiFilial=", ""));
                }

            }
        }

        componentWillMount() {

            if (!Auth.loggedIn()) {
                if (this.doRedirect) {
                    this.props.history.push('/login' + this.redirect);
                } else {
                    this.props.history.push('/' + this.redirect);
                }
                //this.props.history.push('/login/'+this.redirect);
            }
            else {

                if (this.doRedirect) {
                    try {
                        const profile = Auth.getProfile();
                        console.log(profile);
                        this.setState({
                            user: profile
                        })
                    }
                    catch (err) {
                        Auth.logout()
                        this.props.router.push('/login' + this.redirect);
                    }
                } else {
                    this.props.history.push('/' + this.redirect);
                }
            }
        }

        render() {
            if (this.state.user) {

                return (
                    <AuthComponent history={this.props.router} page={this.props} user={this.state.user} />
                )
            }
            else {
                return null
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/WithAuth.js